(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userOrganizationService', userOrganizationService);

    /* @ngInject */
    function userOrganizationService(coreService, config) {
        var countries = 'usa,can,zaf';   
                
        var service = {
            geoCodeByAddress: geoCodeByAddress,
            geoCodeByLocationId: geoCodeByLocationId,
            autocompleteAddressSearch: autocompleteAddressSearch,
            updateOrganizationDetails: updateOrganizationDetails
        };

        activate();

        return service;

        function activate() {
        }

        function geoCodeByLocationId(locationId) {
            var url = '?apiKey=' + config.hereMaps.apiKey + '&locationId=' + encodeURIComponent(locationId) +
                '&maxresults=1';
            return coreService.httpGet(config.hereMaps.geoCodeUrl, url);
        }

        function geoCodeByAddress(address) {
            var url = '?apiKey=' + config.hereMaps.apiKey + '&q=' + encodeURIComponent(address) + '&maxresults=1';
            return coreService.httpGet(config.hereMaps.geoCodeUrl, url);
        }

        function autocompleteAddressSearch(searchText) {
            var url = config.hereMaps.autoCompleteUrl + '?apiKey=' + config.hereMaps.apiKey + '&query=' + encodeURIComponent(searchText) +
                '&maxresults=10&country=' + countries +
                '&resultType=houseNumber';
            return coreService.httpGet(url);
        }

        function updateOrganizationDetails(userId, data) {
            var url = 'user/' + encodeURIComponent(userId) + '/organization';
            return coreService.httpAccountsPost(url, data);
        }
    }
})();
